import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context'
import { MassMessageForm } from '@/modules/online-mass-messages/views/mass-message-form'

export const CreateMassMessageView = () => {
  return (
    <div className="w-full px-14 py-8">
      <DefaultMessageMediaProvider>
        <MessageMediaQueryProvider>
          <MassMessageForm />
        </MessageMediaQueryProvider>
      </DefaultMessageMediaProvider>
    </div>
  )
}
